/**
 * Shared cache-invalidation helpers for the rescue chip lists. Centralized
 * so any mutation that mints new chips (CSV import, single registration,
 * external claim) refetches the SAME query variables the Chips/Dashboard
 * pages actually subscribe to — otherwise the first-page cache stays
 * stale and the newly-minted chips don't appear until the next mount.
 */

import { ChipStatusType } from '@/types/gql-op-types';
import { rescueViewingChipsQuery } from './rescueQueries';

/** First-page size used by the Chips page and matched by any refetch. */
export const CHIPS_PAGE_SIZE = 20;

/**
 * Refetch entries for the SHIPPED + ACTIVE chip lists at page 0. Pass to
 * Apollo's `refetchQueries` or `client.refetchQueries({ include: [...] })`
 * after a mutation that adds chips to either bucket.
 */
export const chipListsFirstPageRefetch = [
  {
    query: rescueViewingChipsQuery,
    variables: { statusType: ChipStatusType.SHIPPED, limit: CHIPS_PAGE_SIZE, offset: 0 },
  },
  {
    query: rescueViewingChipsQuery,
    variables: { statusType: ChipStatusType.ACTIVE, limit: CHIPS_PAGE_SIZE, offset: 0 },
  },
];
